export default __webpack_public_path__ + "static/media/308.33558c24.gif";